import * as core from '../../../../../../../core'

import { query } from './requirements-dashboard-table.query'

export const RESOURCE = {
  payload: {
    alias: 'requirements-dashboard.table',
    description:
      'Drill-down table of requirements, filterable by the widgets above it',
    name: 'Requirements Dashboard - Table',
    query,
    variables: [
      {
        id: 'jiraStatusFilter',
        name: 'Jira Status Filter',
        type: {
          enumId: 'enum::!jira_status',
          isMultiselect: false,
        },
      },
      {
        id: 'typeFilter',
        name: 'Type Filter',
        type: {
          enumId: 'enum::!requirement_type',
          isMultiselect: false,
        },
      },
      {
        id: 'assigneeFilter',
        name: 'Assignee Filter',
        type: {
          dimensionId: 'dim::!personnel',
          isMultiselect: false,
        },
      },
      {
        id: 'dueDateFilter',
        name: 'Due Date Filter',
        type: core.common.value.types.Intrinsic.Date,
      },
    ],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
